import { render, staticRenderFns } from "./LiftLinkBtn.vue?vue&type=template&id=23df87d9&scoped=true&"
import script from "./LiftLinkBtn.vue?vue&type=script&lang=js&"
export * from "./LiftLinkBtn.vue?vue&type=script&lang=js&"
import style0 from "./LiftLinkBtn.vue?vue&type=style&index=0&id=23df87d9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23df87d9",
  null
  
)

export default component.exports